module.exports = __webpack_public_path__ + "static/media/certificate.1f592dca.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/certificate/certificate.pdf
// module id = 597
// module chunks = 0